import { withStyles } from "@material-ui/core/styles"
import React, { PureComponent } from "react"
import CountUp from "react-countup"
import styles from "./styles"

class CountUpComponent extends PureComponent {
  state = {
    start: 0,
    prevEnd: 0
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.end !== prevState.prevEnd) {
      return {
        start: prevState.prevEnd,
        prevEnd: nextProps.end
      }
    }
    return null
  }

  easingFn = (t, b, c, d) => {
    var ts = (t /= d) * t
    var tc = ts * t
    return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t)
  }

  render() {
    const clampedStart = Math.max(0, this.state.start)
    const clampedEnd = Math.max(0, this.state.prevEnd)

    return (
      <CountUp
        start={clampedStart}
        end={clampedEnd}
        duration={this.props.duration || 2}
        prefix={this.props.prefix}
        easingFn={this.easingFn}
        separator=","
        onEnd={() =>
          this.setState({
            start: clampedEnd
          })
        }
      />
    )
  }
}

export default withStyles(styles, { withTheme: true })(CountUpComponent)



// WEBPACK FOOTER //
// ./src/components/CountUp/index.jsx